import { StatusTypes } from "../../../abstract/controller/enum/dnd/StatusTypes";
import useStatus from "../../../abstract/hook/useStatus";
import styles from "./FunctionContainer.module.scss";

function FunctionContainer({ id, children }) {
  const _status = useStatus(id);

  const getClass = () => {
    const _isPositioned = _status === StatusTypes.POSITIONED;

    return `${styles["container"]} ${_isPositioned ? styles["container--hidden"] : ""}`;
  };

  return <div className={getClass()}>{children}</div>;
}

export default FunctionContainer;
